import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs'

class CardProductGallery extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
    this.isHovered = false
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.isTouchDevice = false
  }

  connectedCallback() {
    this.isTouchDevice = window.matchMedia('(pointer: coarse)').matches
    this.initSwiper()
  }

  disconnectedCallback() {
    if (!this.swiper) return
    this.removeEventListener('mouseenter', this.onMouseEnter)
    this.removeEventListener('mouseleave', this.onMouseLeave)
    this.swiper.destroy(true, true)
    this.swiper = null
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 1,
      allowTouchMove: this.isTouchDevice,
      navigation: this.isTouchDevice ? false : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      on: {
        init: () => {
          this.addEventListener('mouseenter', this.onMouseEnter)
          this.addEventListener('mouseleave', this.onMouseLeave)
        },
        slideChangeTransitionStart: () => {
          this.onSlideChange()
        },
      },
    })
  }

  getFirstSlideElement() {
    return this.swiper?.slides?.[0] || null
  }

  getFirstSlideHoverImage() {
    const firstSlideEl = this.getFirstSlideElement()
    if (!firstSlideEl) return null
    return firstSlideEl.querySelector('.hover-image')
  }

  showHoverImage() {
    const hoverImageEl = this.getFirstSlideHoverImage()
    if (hoverImageEl && !hoverImageEl.classList.contains('visible')) {
      hoverImageEl.classList.add('visible')
    }
  }

  hideHoverImage() {
    const hoverImageEl = this.getFirstSlideHoverImage()
    if (hoverImageEl) {
      hoverImageEl.classList.remove('visible')
    }
  }

  onMouseEnter() {
    this.isHovered = true
    if (this.isFirstSlideActive()) {
      this.showHoverImage()
    }
  }

  onMouseLeave() {
    this.isHovered = false
    this.hideHoverImage()
  }
  onSlideChange() {
    if (!this.isFirstSlideActive()) {
      this.hideHoverImage()
      return
    }

    if (this.isHovered) {
      this.showHoverImage()
    } else {
      this.hideHoverImage()
    }
  }

  isFirstSlideActive() {
    const firstSlideEl = this.getFirstSlideElement()
    return !!firstSlideEl && firstSlideEl.classList.contains('swiper-slide-active')
  }
}

class SwipeableCollections extends HTMLElement {
  constructor() {
    super()
    this.swiper = null
  }

  connectedCallback() {
    this.initSwiper()
  }

  disconnectedCallback() {
    if (!this.swiper) return
    this.swiper.destroy(true, true)
    this.swiper = null
  }

  initSwiper() {
    const gap = Number(this.dataset.gap || 10)

    this.swiper = new Swiper(this, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: Number.isFinite(gap) ? gap : 10,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      grabCursor: true
    })
  }
}

if (!customElements.get('card-product-gallery')) {
  customElements.define('card-product-gallery', CardProductGallery)
}

if (!customElements.get('swipeable-collections')) {
  customElements.define('swipeable-collections', SwipeableCollections)
}
